<template>
  <div id="body">
    <base-navigation></base-navigation>

    <base-card>
      <div id="element-to-convert">
          <div class="row">
        <div class="col-lg-6">
          <img
            width="120"
            height="100"
            src="../../assets/shangilia_logo.png"
          />

          <p class="text-primary"> Pay to 522533 account 7944699  </p>

        </div>

        <div class="col-lg-6">
        <small> itibo Wardinians Welfare </small> 
          <br />
      <small>   Benevolent welfare for members </small> 
          <br />
      <small>  Itibo, Nyamira county </small> 
          <br />
      <small>  itibo.roberms.com, itibowelfare@gmail.com </small> 
      <br>
      <!-- <p class="text-primary"> Pay to 522533 account 7944699  </p> -->

        <p class="text-danger">Anyone interested in joining the welfare to pay Kshs 300 to KCB paybill 522533, account 7944699 </p>


          <!-- {{ memberdetails }} -->
        </div>
      </div>

        <div class="row">
          <div class="col-lg-7">
            <small>2026 Membership Report</small>
            <!-- detail {{ memberdetails }} -->
          </div>
          <div class="col-lg-5 text-info" >Date <small> {{ Date().toLocaleString('nl-NL').split("GMT")[0] }}</small></div>
        </div>
        <!-- <div class="row">
          <div class="col-lg-4 text-primary">
            <small>Registration Fee:  <b class="text-danger">{{ total_registrationFee }}</b> </small>
          </div>
        
          <div class="col-lg-4 text-primary">
            <small>Total collected: <b class="text-danger">{{ total_registrationFee + total_buffferAmount + total_caseOneAmount +total_caseTwoAmount + total_caseThreeAmount+total_caseFourAmount + total_caseFiveAmount + total_caseSixAmount+ total_caseSevenAmount + total_caseEightAmount + total_caseNineAmount + total_caseElevenAmount +total_caseTwelveAmount + total_caseThirteenAmount }}</b> </small>
          </div>
          <div class="col-lg-4 text-primary">
            <small>Registered Members: <b class="text-danger">{{ someMembers.length }}</b> </small>
          </div>
   
          <div class="col-lg-4 text-primary">
            <small>Active Members: <b class="text-danger">{{ active_members.length }}</b>  </small>
          </div>
          
        </div> -->

        <br />

       <!-- payments {{ this.$store.getters.joiningMember(2) }} -->

        
        <table class="table myFormat table-striped table-bordered table-sm">
          <thead>
            <tr>
              <!-- <th><h3>Client Id</h3></th> -->
              <th><small>No.</small></th>
              <th><small>Name</small></th>
              <th><small>Balance</small></th>
              <th><small>Reg.</small></th>
              <th><small>Jan</small></th>
              <th><small>Feb</small></th>
              <th><small>March</small></th>
              <th><small>April</small></th>
              <th><small>May</small></th>
              <th><small>June</small></th>

              <th><small>July</small></th>
              <th><small>Aug</small></th>
              <th><small>Sep</small></th>
              <th><small>Oct</small></th>
              <th><small>Nov</small></th>
              <th><small>Dec</small></th>
              <th><small>Total</small></th>

              <!-- <th><h6>Application date</h6></th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(member, index) in memberdetails" :key="member.id">
              <!-- <td>{{ payment.client_id}}</td> -->
              <td>
                <small> {{ index +1}}</small>
              </td>
              <td>
                <!-- <small>{{ member.memberNames.split(" ")[0]  }}</small> -->
                <small>{{ member.member_name }}</small>

              </td>

              <td>
                <small>{{ member.previous_balance }}</small>
              </td>
              <!-- <td>
                <small>{{ member.previous_balance }}</small>
              </td> -->

            
              <td>
                <small>{{ member.registration_amount }}</small>
              </td>

              <td>
                <small>{{ member.Jan }}</small>
              </td>

              <td>
                <small>{{ member.Feb }}</small>
              </td>
              <td>
                <small>{{ member.Mar }}</small>
              </td>

              <td>
                <small>{{ member.Apr }}</small>
              </td>

              <td>
                <small>{{ member.May }}</small>
              </td>

              <td>
                <small>{{ member.Jun }}</small>
              </td>
              <td>
                <small>{{ member.Jul }}</small>
              </td>

              <td>
                <small>{{ member.Aug }}</small>
              </td>

              <td>
                <small>{{ member.Sep }}</small>
              </td>

              <td>
                <small>{{ member.Oct }}</small>
              </td>

              <td>
                <small>{{ member.Nov }}</small>
              </td>

              <td>
                <small>{{ member.Dec }}</small>
              </td>
              <td>
                <small>{{ member.total }}</small>
              </td>

           

              

              

              <!-- <td>{{ new Date(student.reg_date).toLocaleString('nl-NL') }}</td> -->
            </tr>
          </tbody>
        </table>
        <br />
        <br />
       
        <div class="row">
          <br />
        </div>
      </div>

      
      <br>
     
      <button @click="exportToPDF">Download </button>


      <!-- <button @click="exportToPDF">Download</button> -->
      <br />
      <router-link to="/">Go back</router-link>
    </base-card>
  </div>
</template>
<script>
//   import axios from "axios";
import html2pdf from "html2pdf.js";
export default {
    
  methods: {
    exportToPDF() {
      var element = document.getElementById("element-to-convert");
      html2pdf(element, {
        margin: [0, 10, 0, 10], //top, left, buttom, right
        filename: "Itibo wardians report as at " + new Date(Date.now() ).toLocaleString('nl-NL').split(",")[0]  + ".pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          dpi: 192,
          scale: 2,
          logging: true,
          letterRendering: true,
        },
        jsPDF: { unit: "mm", format: [300, 1500], orientation: "portrait" },
      });
    },
  },

   

  computed: {
      memberdetails() {
            return  this.$store.getters.allMembers

            
        },
        someMembers(){


         return  this.$store.getters.newmembers 
        },
        membercases() {
            return  this.$store.getters.allcases

            
        },
        payments() {
          return  this.$store.getters.allPayments

          
      },
      active_members() {
          return  this.$store.getters.newmembers.filter((col) => col.buffer_amount == 2000).filter((col) => col.case_8_amount == 450).filter((col) => col.processed == 1)

          
      },
      caaseDate(){
        return this.allCases.filter(caseItem => caseItem.id === Number(this.caseId));

      },
      
      memberPayments() {
          return  this.$store.getters.payments//.filter((col) => col.member_id == memberId)

          
      },
      total_registrationFee() {
      return this.someMembers
        .reduce((acc, item) => acc + parseInt(item.registration_amount), 0);
    },
    total_buffferAmount() {
      return this.someMembers
        .reduce((acc, item) => acc + parseInt(item.buffer_amount), 0);
    },
    total_caseOneAmount() {
      return this.someMembers
        .reduce((acc, item) => acc + parseInt(item.case_1_amount), 0);
    },
    total_caseTwoAmount() {
      return this.someMembers
        .reduce((acc, item) => acc + parseInt(item.case_2_amount), 0);
    },
    total_caseThreeAmount() {
      return this.someMembers
        .reduce((acc, item) => acc + parseInt(item.case_3_amount), 0);
    },
    total_caseFourAmount() {
      return this.someMembers
        .reduce((acc, item) => acc + parseInt(item.case_4_amount), 0);
    },
          total_caseFiveAmount() {
      return this.someMembers
        .reduce((acc, item) => acc + parseInt(item.case_5_amount), 0);
    },
          total_caseSixAmount() {
      return this.someMembers
        .reduce((acc, item) => acc + parseInt(item.case_6_amount), 0);
    },
     total_caseSevenAmount() {
      return this.someMembers
        .reduce((acc, item) => acc + parseInt(item.case_7_amount), 0);
    },

    total_caseEightAmount() {
      return this.someMembers
        .reduce((acc, item) => acc + parseInt(item.case_8_amount), 0);
    },
    total_caseNineAmount() {
      return this.someMembers
        .reduce((acc, item) => acc + parseInt(item.case_9_amount), 0);
    },

    total_caseElevenAmount() {
      return this.someMembers
        .reduce((acc, item) => acc + parseInt(item.case_11_amount), 0);
    },

    total_caseTwelveAmount() {
      return this.someMembers
        .reduce((acc, item) => acc + parseInt(item.case_12_amount), 0);
    },

    
    total_caseThirteenAmount() {
      return this.someMembers
        .reduce((acc, item) => acc + parseInt(item.case_13_amount), 0);
    },
    
    
    
    
      


   
   
  },
  created() {
    this.$store.dispatch("LoadMembers");
    this.$store.dispatch('LoadPayments'); 
    this.$store.dispatch('LoadNewmembers');   
    this.$store.dispatch('LoadCases'); 
    

  
  },
};
</script>

<style scoped>
table.myFormat tr td { font-size: 12px; }
</style>